module.exports = __webpack_public_path__ + "img/6-text.593a804b.png";